var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.0829 34.0416C21.0159 34.0416 24.8273 32.678 27.8677 30.183C30.908 27.6879 32.9891 24.2159 33.7565 20.3584C34.5239 16.501 33.93 12.4968 32.076 9.02814C30.2221 5.55947 27.2228 2.84096 23.5891 1.33579C19.9555 -0.169383 15.9124 -0.368077 12.1487 0.773562C8.38498 1.9152 5.13357 4.32654 2.94844 7.5967C0.763309 10.8669 -0.220334 14.7935 0.165113 18.7076C0.55056 22.6217 2.28125 26.2811 5.06228 29.0622C6.63722 30.6457 8.51056 31.9011 10.5739 32.7558C12.6372 33.6105 14.8496 34.0475 17.0829 34.0416ZM7.38744 7.34613C9.25513 5.47848 11.6226 4.1901 14.2051 3.63593C16.7876 3.08175 19.4752 3.28537 21.9447 4.22231C24.4142 5.15924 26.5605 6.78959 28.1255 8.91731C29.6905 11.045 30.6075 13.5795 30.7664 16.216C30.9252 18.8525 30.319 21.4788 29.0208 23.779C27.7225 26.0792 25.7875 27.9554 23.4483 29.182C21.1091 30.4087 18.4654 30.9334 15.835 30.6933C13.2047 30.4531 10.6997 29.4583 8.62131 27.8284L19.8248 16.6248V23.0738H23.1152V12.6545C23.1152 12.2182 22.9418 11.7997 22.6333 11.4912C22.3248 11.1827 21.9063 11.0094 21.47 11.0094H11.0507V14.2997H17.4997L6.29615 25.5032C4.22944 22.8662 3.19989 19.5637 3.40196 16.2194C3.60403 12.8751 5.02374 9.72058 7.39293 7.35162L7.38744 7.34613Z",
    fill: "#FFC907"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.71d3a0f9b7b0bcfcf68f19cc48b10fbb.svg";
export { ForwardRef as ReactComponent };